import React from 'react';

const INTERVAL = 50;

const usePausableTimer = (isPaused = false, intervalInMs = INTERVAL): number => {
  const [elapsedMs, setElapsedMs] = React.useState(0);

  React.useEffect(() => {
    if (isPaused) {
      return undefined;
    }
    const interval = setInterval(() => {
      setElapsedMs(prev => prev + intervalInMs);
    }, intervalInMs);
    return () => clearInterval(interval);
  }, [isPaused, intervalInMs]);

  return elapsedMs;
};

export default usePausableTimer;
